// crm namespace — Email preview (admin/crm/email/preview/*): the rendered draft of a
// sequence step, the birthday message or a broadcast, and "Send test to me".
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "emailPreview.preview": "Aperçu",
    "emailPreview.title": "Aperçu de l'e-mail",
    "emailPreview.sendTestToMe": "M'envoyer un test",
    "emailPreview.from": "De",
    "emailPreview.subject": "Objet",
    "emailPreview.frameTitle": "Contenu de l'e-mail",
    "emailPreview.sampleNote": "Affiché avec un client fictif. Les liens de l'aperçu ne fonctionnent pas.",
    "emailPreview.loading": "Préparation de l'aperçu…",
  },
  en: {
    "emailPreview.preview": "Preview",
    "emailPreview.title": "Email preview",
    "emailPreview.sendTestToMe": "Send test to me",
    "emailPreview.from": "From",
    "emailPreview.subject": "Subject",
    "emailPreview.frameTitle": "Email content",
    "emailPreview.sampleNote": "Shown with a sample client. Links in the preview don't work.",
    "emailPreview.loading": "Preparing the preview…",
  },
  es: {
    "emailPreview.preview": "Vista previa",
    "emailPreview.title": "Vista previa del correo",
    "emailPreview.sendTestToMe": "Enviarme una prueba",
    "emailPreview.from": "De",
    "emailPreview.subject": "Asunto",
    "emailPreview.frameTitle": "Contenido del correo",
    "emailPreview.sampleNote": "Se muestra con un cliente de ejemplo. Los enlaces de la vista previa no funcionan.",
    "emailPreview.loading": "Preparando la vista previa…",
  },
};
